import { useEffect, useState } from "react";
import ScoreBar from "./ScoreBar";

const LoadingScoreBar = (props) => {
  const text = props.text;
  const [score, setScore] = useState(0);

  const [show, setShow] = useState(true);

  const sleep = (time) => {
    return new Promise((resolve) => setTimeout(resolve, time));
  };

  useEffect(() => {
    if (score > 100) setScore(0);
    else
      sleep(80).then(() => {
        setScore(score + 1);
      });

    return () => setShow(false);
  }, [score]);

  return !show && <ScoreBar score={score} alttext={text}></ScoreBar>;
};

export default LoadingScoreBar;
